/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const regionDataSchema = z.object({
	id: z.string(),
	name: z.string(),
})

export type RegionDataSchema = z.infer<typeof regionDataSchema>
